import React, { useState } from 'react';
import { Card } from 'react-bootstrap';
import RecallPoolTable from './RecallPoolTable';

function RecallPools() {
    const [searchPanelOpen, setSearchPanelOpen] = useState(false);

    return (
        <div className="container-fluid">
            <div className="pagetitle d-flex justify-content-between align-items-end flex-wrap gap-2">
                <div>
                    <h1 className="mb-1">
                        <i className="bi bi-people"></i> Recall Pools
                    </h1>
                    <p className="recall-page__meta mb-0">
                        Browse and manage patients in the recall pool across clinics.
                    </p>
                </div>
                <button
                    type="button"
                    className="btn btn-outline-secondary btn-sm flex-shrink-0"
                    onClick={() => setSearchPanelOpen((open) => !open)}
                    aria-expanded={searchPanelOpen}
                    title={searchPanelOpen ? 'Hide filters' : 'Show filters'}
                >
                    <i className="bi bi-funnel me-1"></i>
                    Filter
                </button>
            </div>

            <Card className="card-padding shadow-sm border-0">
                <Card.Body className="p-3">
                    <RecallPoolTable searchPanelOpen={searchPanelOpen} />
                </Card.Body>
            </Card>
        </div>
    );
}

export default RecallPools;
